import { actions } from "store/actions";

const initialState = { rates: [] };

export const ratesReducers = {
  rates(state = initialState.rates, action) {
    switch (action.type) {
      case actions.VM_SET_RATES:
        return action.payload;
      default:
        return state;
    }
  },
};
